var map = {
	"./Valenbisi.svg": 70194,
	"./bici.svg": 95877,
	"./coche.svg": 40410,
	"./destiny.svg": 70236,
	"./fold-location-map.svg": 61585,
	"./half-occupancy.svg": 60193,
	"./high-occupancy.svg": 82020,
	"./icono-mapa-actual2.svg": 10904,
	"./low-occupancy.svg": 88020,
	"./map-icons-markers/icons/abseiling.svg": 62260,
	"./map-icons-markers/icons/accounting.svg": 43444,
	"./map-icons-markers/icons/airport.svg": 95215,
	"./map-icons-markers/icons/amusement-park.svg": 59406,
	"./map-icons-markers/icons/aquarium.svg": 44371,
	"./map-icons-markers/icons/archery.svg": 18563,
	"./map-icons-markers/icons/art-gallery.svg": 66718,
	"./map-icons-markers/icons/assistive-listening-system.svg": 47857,
	"./map-icons-markers/icons/atm.svg": 39259,
	"./map-icons-markers/icons/audio-description.svg": 66263,
	"./map-icons-markers/icons/bakery.svg": 27110,
	"./map-icons-markers/icons/bank.svg": 46164,
	"./map-icons-markers/icons/bar.svg": 28840,
	"./map-icons-markers/icons/baseball.svg": 95556,
	"./map-icons-markers/icons/beauty-salon.svg": 32138,
	"./map-icons-markers/icons/bicycle-store.svg": 75267,
	"./map-icons-markers/icons/bicycling.svg": 52415,
	"./map-icons-markers/icons/boat-ramp.svg": 96505,
	"./map-icons-markers/icons/boat-tour.svg": 59979,
	"./map-icons-markers/icons/boating.svg": 51059,
	"./map-icons-markers/icons/book-store.svg": 33423,
	"./map-icons-markers/icons/bowling-alley.svg": 4578,
	"./map-icons-markers/icons/braille.svg": 64126,
	"./map-icons-markers/icons/bus-station.svg": 70169,
	"./map-icons-markers/icons/cafe.svg": 85675,
	"./map-icons-markers/icons/campground.svg": 4683,
	"./map-icons-markers/icons/canoe.svg": 65244,
	"./map-icons-markers/icons/car-dealer.svg": 21919,
	"./map-icons-markers/icons/car-rental.svg": 87274,
	"./map-icons-markers/icons/car-repair.svg": 4899,
	"./map-icons-markers/icons/car-wash.svg": 83828,
	"./map-icons-markers/icons/casino.svg": 61447,
	"./map-icons-markers/icons/cemetery.svg": 12375,
	"./map-icons-markers/icons/chairlift.svg": 84615,
	"./map-icons-markers/icons/church.svg": 67985,
	"./map-icons-markers/icons/circle.svg": 10255,
	"./map-icons-markers/icons/city-hall.svg": 90783,
	"./map-icons-markers/icons/climbing.svg": 66133,
	"./map-icons-markers/icons/closed-captioning.svg": 12441,
	"./map-icons-markers/icons/clothing-store.svg": 92831,
	"./map-icons-markers/icons/compass.svg": 64113,
	"./map-icons-markers/icons/convenience-store.svg": 41325,
	"./map-icons-markers/icons/courthouse.svg": 83146,
	"./map-icons-markers/icons/cross-country-skiing.svg": 57585,
	"./map-icons-markers/icons/crosshairs.svg": 1128,
	"./map-icons-markers/icons/dentist.svg": 59127,
	"./map-icons-markers/icons/department-store.svg": 60912,
	"./map-icons-markers/icons/diving.svg": 69085,
	"./map-icons-markers/icons/doctor.svg": 98840,
	"./map-icons-markers/icons/electrician.svg": 92858,
	"./map-icons-markers/icons/electronics-store.svg": 4944,
	"./map-icons-markers/icons/embassy.svg": 78110,
	"./map-icons-markers/icons/expand.svg": 78493,
	"./map-icons-markers/icons/female.svg": 90729,
	"./map-icons-markers/icons/finance.svg": 5636,
	"./map-icons-markers/icons/fire-station.svg": 19814,
	"./map-icons-markers/icons/fish-cleaning.svg": 77545,
	"./map-icons-markers/icons/fishing-pier.svg": 37807,
	"./map-icons-markers/icons/fishing.svg": 70180,
	"./map-icons-markers/icons/florist.svg": 84957,
	"./map-icons-markers/icons/food.svg": 3420,
	"./map-icons-markers/icons/fullscreen.svg": 33070,
	"./map-icons-markers/icons/funeral-home.svg": 29487,
	"./map-icons-markers/icons/furniture-store.svg": 58031,
	"./map-icons-markers/icons/gas-station.svg": 62371,
	"./map-icons-markers/icons/general-contractor.svg": 41624,
	"./map-icons-markers/icons/golf.svg": 31573,
	"./map-icons-markers/icons/grocery-or-supermarket.svg": 58430,
	"./map-icons-markers/icons/gym.svg": 78112,
	"./map-icons-markers/icons/hair-care.svg": 96445,
	"./map-icons-markers/icons/hang-gliding.svg": 9378,
	"./map-icons-markers/icons/hardware-store.svg": 45007,
	"./map-icons-markers/icons/health.svg": 33698,
	"./map-icons-markers/icons/hindu-temple.svg": 57204,
	"./map-icons-markers/icons/horse-riding.svg": 90024,
	"./map-icons-markers/icons/hospital.svg": 67087,
	"./map-icons-markers/icons/ice-fishing.svg": 27297,
	"./map-icons-markers/icons/ice-skating.svg": 32687,
	"./map-icons-markers/icons/inline-skating.svg": 47531,
	"./map-icons-markers/icons/insurance-agency.svg": 81546,
	"./map-icons-markers/icons/jet-skiing.svg": 40422,
	"./map-icons-markers/icons/jewelry-store.svg": 3355,
	"./map-icons-markers/icons/kayaking.svg": 76964,
	"./map-icons-markers/icons/laundry.svg": 16431,
	"./map-icons-markers/icons/lawyer.svg": 59768,
	"./map-icons-markers/icons/library.svg": 28215,
	"./map-icons-markers/icons/liquor-store.svg": 64241,
	"./map-icons-markers/icons/local-government.svg": 8197,
	"./map-icons-markers/icons/location-arrow.svg": 74692,
	"./map-icons-markers/icons/locksmith.svg": 52393,
	"./map-icons-markers/icons/lodging.svg": 655,
	"./map-icons-markers/icons/low-vision-access.svg": 5318,
	"./map-icons-markers/icons/male.svg": 81751,
	"./map-icons-markers/icons/map-pin.svg": 92329,
	"./map-icons-markers/icons/marina.svg": 35649,
	"./map-icons-markers/icons/mosque.svg": 98121,
	"./map-icons-markers/icons/motobike-trail.svg": 48646,
	"./map-icons-markers/icons/movie-rental.svg": 34731,
	"./map-icons-markers/icons/movie-theater.svg": 60157,
	"./map-icons-markers/icons/moving-company.svg": 60871,
	"./map-icons-markers/icons/museum.svg": 13168,
	"./map-icons-markers/icons/natural-feature.svg": 72481,
	"./map-icons-markers/icons/night-club.svg": 60686,
	"./map-icons-markers/icons/open-captioning.svg": 36524,
	"./map-icons-markers/icons/painter.svg": 93720,
	"./map-icons-markers/icons/park.svg": 72858,
	"./map-icons-markers/icons/parking.svg": 27843,
	"./map-icons-markers/icons/pet-store.svg": 20518,
	"./map-icons-markers/icons/pharmacy.svg": 80530,
	"./map-icons-markers/icons/physiotherapist.svg": 67748,
	"./map-icons-markers/icons/place-of-worship.svg": 35460,
	"./map-icons-markers/icons/playground.svg": 12898,
	"./map-icons-markers/icons/plumber.svg": 86296,
	"./map-icons-markers/icons/point-of-interest.svg": 96653,
	"./map-icons-markers/icons/police.svg": 12522,
	"./map-icons-markers/icons/political.svg": 51479,
	"./map-icons-markers/icons/post-box.svg": 48509,
	"./map-icons-markers/icons/post-office.svg": 12274,
	"./map-icons-markers/icons/postal-code-prefix.svg": 59667,
	"./map-icons-markers/icons/postal-code.svg": 15870,
	"./map-icons-markers/icons/rafting.svg": 21669,
	"./map-icons-markers/icons/real-estate-agency.svg": 18994,
	"./map-icons-markers/icons/restaurant.svg": 62735,
	"./map-icons-markers/icons/roofing-contractor.svg": 93786,
	"./map-icons-markers/icons/route-pin.svg": 13571,
	"./map-icons-markers/icons/route.svg": 85511,
	"./map-icons-markers/icons/rv-park.svg": 54756,
	"./map-icons-markers/icons/sailing.svg": 90015,
	"./map-icons-markers/icons/school.svg": 58453,
	"./map-icons-markers/icons/scuba-diving.svg": 27026,
	"./map-icons-markers/icons/search.svg": 53157,
	"./map-icons-markers/icons/sheild.svg": 60635,
	"./map-icons-markers/icons/shopping-mall.svg": 44152,
	"./map-icons-markers/icons/sign-language.svg": 42423,
	"./map-icons-markers/icons/skateboarding.svg": 83913,
	"./map-icons-markers/icons/ski-jumping.svg": 75339,
	"./map-icons-markers/icons/skiing.svg": 1739,
	"./map-icons-markers/icons/sledding.svg": 65129,
	"./map-icons-markers/icons/snow-shoeing.svg": 5801,
	"./map-icons-markers/icons/snow.svg": 3041,
	"./map-icons-markers/icons/snowboarding.svg": 33023,
	"./map-icons-markers/icons/snowmobile.svg": 67030,
	"./map-icons-markers/icons/spa.svg": 98086,
	"./map-icons-markers/icons/square-pin.svg": 58730,
	"./map-icons-markers/icons/square-rounded.svg": 35678,
	"./map-icons-markers/icons/square.svg": 31753,
	"./map-icons-markers/icons/stadium.svg": 35625,
	"./map-icons-markers/icons/storage.svg": 26979,
	"./map-icons-markers/icons/store.svg": 83333,
	"./map-icons-markers/icons/subway-station.svg": 23787,
	"./map-icons-markers/icons/surfing.svg": 88483,
	"./map-icons-markers/icons/swimming.svg": 20491,
	"./map-icons-markers/icons/synagogue.svg": 54459,
	"./map-icons-markers/icons/taxi-stand.svg": 80795,
	"./map-icons-markers/icons/tennis.svg": 45857,
	"./map-icons-markers/icons/toilet.svg": 39304,
	"./map-icons-markers/icons/trail-walking.svg": 5848,
	"./map-icons-markers/icons/train-station.svg": 64623,
	"./map-icons-markers/icons/transit-station.svg": 98100,
	"./map-icons-markers/icons/travel-agency.svg": 40609,
	"./map-icons-markers/icons/unisex.svg": 92113,
	"./map-icons-markers/icons/university.svg": 22074,
	"./map-icons-markers/icons/veterinary-care.svg": 33204,
	"./map-icons-markers/icons/viewing.svg": 44048,
	"./map-icons-markers/icons/volume-control-telephone.svg": 22518,
	"./map-icons-markers/icons/walking.svg": 39078,
	"./map-icons-markers/icons/waterskiing.svg": 7699,
	"./map-icons-markers/icons/whale-watching.svg": 9188,
	"./map-icons-markers/icons/wheelchair.svg": 46470,
	"./map-icons-markers/icons/wind-surfing.svg": 14536,
	"./map-icons-markers/icons/zoo.svg": 66041,
	"./map-icons-markers/icons/zoom-in-alt.svg": 8218,
	"./map-icons-markers/icons/zoom-in.svg": 12344,
	"./map-icons-markers/icons/zoom-out-alt.svg": 71424,
	"./map-icons-markers/icons/zoom-out.svg": 9758,
	"./map-icons-markers/markers/map-pin.svg": 53862,
	"./map-icons-markers/markers/route.svg": 64345,
	"./map-icons-markers/markers/shield.svg": 55496,
	"./map-icons-markers/markers/square-pin.svg": 27884,
	"./map-icons-markers/markers/square-rounded.svg": 44231,
	"./map-icons-markers/markers/square.svg": 81655,
	"./motor-cicle.svg": 12247,
	"./motorcycle.svg": 42056,
	"./stop-selected.svg": 71103,
	"./taxi.svg": 80838,
	"./valenbici-map.svg": 39180,
	"./walk.svg": 5769
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52354;